(function() { window.GUID_5f1120bb_8dba_4bc9_bc7f_36cf64aed05b = { getGuid: function() { return "5f1120bb-8dba-4bc9-bc7f-36cf64aed05b"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Filters extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.layoutState = {
                    collapsed: true,
                };
                /**
                 * Used to keep track of the state of all the filter inputs.
                 */
                this.inputsState = {};
                /**
                 * Used to keep track of the state of all the filter date-pickers.
                 */
                this.datePickersState = {};
                this.handlePersonaDropdownItemClick = (value, overridableUrl) => __awaiter(this, void 0, void 0, function* () {
                    const filterType = CS.Enumeration.FilterType.OnlyEntitiesResults;
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const filterContext = $("#FiltersContext").val();
                    const data = {
                        value: value,
                        filterType: filterType,
                        context: filterContext,
                        overridableUrl: overridableUrl,
                        toggleUrl: null,
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    CS.Lag("autocomplete-persona-dropdown-clear-overlay", 50, () => {
                        const $dropdownOverlay = $(".dropdown-overlay");
                        if ($dropdownOverlay.length) {
                            $dropdownOverlay.remove();
                        }
                    });
                    this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: null, data });
                });
                this.handleEventDropdownItemClick = (value, overridableUrl) => __awaiter(this, void 0, void 0, function* () {
                    const filterType = CS.Enumeration.FilterType.Events;
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const filterContext = $("#FiltersContext").val();
                    const data = {
                        value: value,
                        filterType: filterType,
                        context: filterContext,
                        overridableUrl: overridableUrl,
                        toggleUrl: null,
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: null, data });
                });
                this.handleOperatorDropdownItemClick = (value, overridableUrl) => __awaiter(this, void 0, void 0, function* () {
                    const filterType = CS.Enumeration.FilterType.Operators;
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const filterContext = $("#FiltersContext").val();
                    const data = {
                        value: value,
                        filterType: filterType,
                        context: filterContext,
                        overridableUrl: overridableUrl,
                        toggleUrl: null,
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: null, data });
                });
                this.handleDivisionClick = (value, overridableUrl) => __awaiter(this, void 0, void 0, function* () {
                    const filterType = CS.Enumeration.FilterType.Divisions;
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const filterContext = $("#FiltersContext").val();
                    //Remove back from popstate
                    CS.PopState.GoBackIfNotAlreadyDone();
                    const data = {
                        value: value,
                        filterType: filterType,
                        context: filterContext,
                        overridableUrl: overridableUrl,
                        toggleUrl: null,
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: null, data });
                });
                this.handleSortChipClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    const $sortChip = $(e.currentTarget);
                    const url = $sortChip.data("url");
                    const data = {
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.SortItemClicked, { jqueryEventObject: e, data });
                });
                this.handleSortItemClick = (list, e) => __awaiter(this, void 0, void 0, function* () {
                    const url = e.data.value;
                    const data = {
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.SortItemClicked, { jqueryEventObject: e.jqueryEventObject, data });
                });
                this.handleDateChange = (datePicker, e) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const id = datePicker.$Control.attr("id");
                    //Update the datePicker's value.
                    this.datePickersState[id].changedRecently = true;
                    this.datePickersState[id].value = datePicker.GetValue();
                    const filterType = this.datePickersState[id].filterType;
                    const filterContext = this.datePickersState[id].filterContext;
                    // Extract overridable URL from UI. Return if it's not defined.
                    const $overridableUrlInput = $(`.filter-overridable-url[data-filter-type="${filterType}"]`);
                    if (!$overridableUrlInput.length)
                        return;
                    const overridableUrl = $overridableUrlInput.val();
                    if (overridableUrl == null ||
                        typeof overridableUrl !== "string" ||
                        CS.Helper.isNullOrWhiteSpace(overridableUrl))
                        return;
                    // Extract toggle switch URL from UI.
                    const $toggleUrlSwitch = $(`#checkbox-filter-item-switch-${filterType}`);
                    const toggleUrl = $toggleUrlSwitch.length
                        ? (_b = (_a = $toggleUrlSwitch.data("html")) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : null
                        : null;
                    // Find all inputs with the same filter type and filter context in this.datePickersState.
                    const inputsOfSameFilter = Object.keys(this.datePickersState).filter((key) => this.datePickersState[key].filterType === filterType &&
                        this.datePickersState[key].filterContext === filterContext);
                    // Sort the inputs by their index.
                    inputsOfSameFilter.sort((a, b) => {
                        return this.datePickersState[a].index - this.datePickersState[b].index;
                    });
                    // Extract the values of the inputs.
                    const values = inputsOfSameFilter.map((key) => this.datePickersState[key].value);
                    const value = values.join(",");
                    // Build url/data from the values.
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const data = {
                        value: value,
                        filterType: filterType,
                        context: filterContext,
                        overridableUrl: overridableUrl,
                        toggleUrl: toggleUrl,
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    // Trigger the event.
                    this.Trigger(Filters.EventNames.TextChanged, { jqueryEventObject: null, data });
                });
                this.handleTextChange = (textBox, e) => {
                    const id = textBox.$Control.attr("id");
                    // Flag the input as having changed recently and update it's value.
                    this.inputsState[id].value = textBox.GetValue();
                    this.inputsState[id].changedRecently = true;
                    CS.Lag(id, 1000, () => __awaiter(this, void 0, void 0, function* () {
                        // Automatically clear the changed flag after 1 second and re-update it's value, since it might have changed again.
                        var _a, _b;
                        this.inputsState[id].changedRecently = false;
                        this.inputsState[id].value = textBox.GetValue();
                        // Find out if any input changed recently.
                        const anyInputChangedRecently = Object.keys(this.inputsState).some((key) => this.inputsState[key].changedRecently);
                        // If none of the inputs changed recently, proceed.
                        if (!anyInputChangedRecently) {
                            const filterType = this.inputsState[id].filterType;
                            const filterContext = this.inputsState[id].filterContext;
                            // Extract overridable URL from UI. Return if it's not defined.
                            const $overridableUrlInput = $(`.filter-overridable-url[data-filter-type="${filterType}"]`);
                            if (!$overridableUrlInput.length)
                                return;
                            const overridableUrl = $overridableUrlInput.val();
                            if (overridableUrl == null ||
                                typeof overridableUrl !== "string" ||
                                CS.Helper.isNullOrWhiteSpace(overridableUrl))
                                return;
                            // Extract toggle switch URL from UI.
                            const $toggleUrlSwitch = $(`#checkbox-filter-item-switch-${filterType}`);
                            const toggleUrl = $toggleUrlSwitch.length
                                ? (_b = (_a = $toggleUrlSwitch.data("html")) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : null
                                : null;
                            // Find all inputs with the same filter type and filter context in this.inputsState.
                            const inputsOfSameFilter = Object.keys(this.inputsState).filter((key) => this.inputsState[key].filterType === filterType &&
                                this.inputsState[key].filterContext === filterContext);
                            // Sort the inputs by their index.
                            inputsOfSameFilter.sort((a, b) => {
                                return this.inputsState[a].index - this.inputsState[b].index;
                            });
                            // Extract the values of the inputs.
                            const values = inputsOfSameFilter.map((key) => this.inputsState[key].value);
                            const value = values.join(",");
                            // Build url/data from the values.
                            const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                            const data = {
                                value: value,
                                filterType: filterType,
                                context: filterContext,
                                overridableUrl: overridableUrl,
                                toggleUrl: toggleUrl,
                                url: url,
                                filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                            };
                            // Trigger the event.
                            this.Trigger(Filters.EventNames.TextChanged, { jqueryEventObject: null, data });
                        }
                    }));
                };
                this.handleAutocompleteItemClick = (list, e) => __awaiter(this, void 0, void 0, function* () {
                    var _c, _d;
                    const { filterType, context: filterContext } = e.data.extraValues;
                    if (filterType != null && filterContext != null) {
                        let value = e.data.value;
                        if (value == null ||
                            (typeof value === "string" && CS.Helper.isNullOrWhiteSpace(value))) {
                            value = this.OverridableValuePrefixAndSuffix;
                        }
                        const $overridableUrlInput = $(`.filter-overridable-url[data-filter-type="${filterType}"]`);
                        if (!$overridableUrlInput.length)
                            return;
                        const overridableUrl = $overridableUrlInput.val();
                        if (overridableUrl == null ||
                            typeof overridableUrl !== "string" ||
                            CS.Helper.isNullOrWhiteSpace(overridableUrl))
                            return;
                        const $toggleUrlSwitch = $(`#checkbox-filter-item-switch-${filterType}`);
                        const toggleUrl = $toggleUrlSwitch.length
                            ? (_d = (_c = $toggleUrlSwitch.data("html")) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null
                            : null;
                        const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                        const data = {
                            value: value,
                            filterType: filterType,
                            overridableUrl: overridableUrl,
                            url: url,
                            toggleUrl: toggleUrl,
                            context: filterContext,
                            filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                        };
                        this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: e.jqueryEventObject, data });
                    }
                });
                /**
                 * Extract data from the given item and trigger the appropriate event.
                 */
                this.handleItemClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    var _e, _f;
                    const $item = $(e.currentTarget);
                    const $dropdownParent = $item.closest(".dropdown");
                    // Since the selection mode is None (in case there's child dropdowns),
                    // we need to close the dropdown manually.
                    const closeDropdown = () => {
                        if ($dropdownParent.length) {
                            const dropdownId = $dropdownParent.attr("id");
                            const $picker = $(`[data-pickerof="${dropdownId}"]`);
                            if ($picker.length) {
                                const dropdown = CS.Controls.GetInstance(Controls.DropDown, "#" + dropdownId, true);
                                if (dropdown != null)
                                    dropdown.Close();
                                CS.Lag(dropdownId, 50, () => {
                                    const $dropdownOverlay = $(".dropdown-overlay");
                                    if ($dropdownOverlay.length) {
                                        $dropdownOverlay.remove();
                                    }
                                });
                            }
                        }
                    };
                    let value = $item.data("value");
                    if (value == null ||
                        (typeof value === "string" && CS.Helper.isNullOrWhiteSpace(value)))
                        value = this.OverridableValuePrefixAndSuffix;
                    const filterType = $item.data("filter-type");
                    if (filterType == null)
                        return closeDropdown();
                    const filterContext = $item.data("filter-context");
                    if (filterContext == null)
                        return closeDropdown();
                    const $overridableUrlInput = $(`.filter-overridable-url[data-filter-type="${filterType}"]`);
                    if (!$overridableUrlInput.length)
                        return closeDropdown();
                    const overridableUrl = $overridableUrlInput.val();
                    if (overridableUrl == null ||
                        typeof overridableUrl !== "string" ||
                        CS.Helper.isNullOrWhiteSpace(overridableUrl)) {
                        return closeDropdown();
                    }
                    const $toggleUrlSwitch = $(`#checkbox-filter-item-switch-${filterType}`);
                    const toggleUrl = $toggleUrlSwitch.length
                        ? (_f = (_e = $toggleUrlSwitch.data("html")) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : null
                        : null;
                    const url = yield this.replaceValueInOverridableUrl(overridableUrl, value, filterType);
                    const data = {
                        value: value,
                        filterType: filterType,
                        overridableUrl: overridableUrl,
                        url: url,
                        toggleUrl: toggleUrl,
                        context: filterContext,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    closeDropdown();
                    if (value == "custom-preset")
                        return this.toggleCollapsedLayoutState(true);
                    this.Trigger(Filters.EventNames.ItemClicked, { jqueryEventObject: e, data });
                });
                /**
                 * Extract data from the toggle switch and trigger the appropriate event.
                 */
                this.handleToggleClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    const $checkbox = $(e.currentTarget);
                    const checkbox = $checkbox.length
                        ? Controls.GetInstance(Controls.CheckBox, $checkbox, true)
                        : null;
                    if (checkbox == null || checkbox.IsDisabled)
                        return;
                    const { url, filterType, filterContext } = $checkbox.data("html");
                    if (url == null ||
                        (typeof url !== "string" && CS.Helper.isNullOrWhiteSpace(url)))
                        return;
                    if (filterType == null ||
                        (typeof filterType !== "string" &&
                            CS.Helper.isNullOrWhiteSpace(filterType)))
                        return;
                    if (filterContext == null ||
                        (typeof filterContext !== "string" &&
                            CS.Helper.isNullOrWhiteSpace(filterContext)))
                        return;
                    const data = {
                        toggleUrl: url,
                        filterType: filterType,
                        context: filterContext,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(Filters.EventNames.FilterToggleClicked, { jqueryEventObject: e, data });
                });
            }
            get OverridableValuePrefixAndSuffix() {
                return this.overridableValuePrefixAndSuffix;
            }
            get InDrawer() {
                if (typeof this.inDrawer === "string") {
                    this.inDrawer = this.inDrawer === "true";
                }
                return this.inDrawer;
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.overridableValuePrefixAndSuffix = params[1];
                this.inDrawer = params[2];
            }
            OnControlRendered() {
                const $topbarFiltersLabel = CS.DOM.$topBar.find(".filters .label");
                if ($topbarFiltersLabel.length) {
                    const $filtersCount = $("#ActiveFiltersCount");
                    if ($filtersCount.length && $filtersCount.val() != null) {
                        $topbarFiltersLabel.text(`(${$filtersCount.val()})`);
                    }
                }
                //if (window.CSS.supports("overflow-y", "scroll")) {
                const $filtersToggle = this.$Control.find(".filters-toggle");
                if ($filtersToggle.length) {
                    $filtersToggle.css({
                        bottom: `${CS.DOM.$sectionBottom.outerHeight() - 1}px`,
                    });
                }
                //}
            }
            OnBindEvents() {
                CS.DOM.$body.offon("click.filterItemClicked", ".item[data-filter-type]", this.handleItemClick);
                Controls.DropDown.Events.ListItemClicked({
                    selector: CS.DOM.$body,
                    childSelector: ".cs-filter-dropdown",
                    callback: this.handleAutocompleteItemClick,
                });
                // DropDown.Events.ListItemClicked({
                //   selector: DOM.$body,
                //   childSelector: ".cs-sort-dropdown",
                //   callback: this.handleSortItemClick,
                // });
                CS.DOM.$body.offon("click.sortItemClick", ".cs-sorting-chip", (e) => __awaiter(this, void 0, void 0, function* () {
                    yield this.handleSortChipClick(e);
                }));
                CS.DOM.$body.offon("click.filterToggleClicked", ".checkbox.filter-item__switch", this.handleToggleClick);
                Controls.TextBox.Events.TextChanged({
                    selector: CS.DOM.$body,
                    childSelector: ".control-cs.cs-filter-input",
                    callback: this.handleTextChange,
                });
                Controls.DatePicker.Events.DatePickerValueChanged({
                    selector: CS.DOM.$body,
                    childSelector: ".control-cs.cs-filter-input.datepicker",
                    callback: this.handleDateChange,
                });
                Controls.PersonaPicker.Events.PersonaItemClicked({
                    selector: CS.DOM.$body,
                    childSelector: "#cs-persona-picker-filters",
                    callback: (personaPicker, e) => __awaiter(this, void 0, void 0, function* () {
                        const { personaId } = e.data;
                        if (CS.Helper.isNullOrWhiteSpace(personaId))
                            return;
                        const $filter = personaPicker.$Control.closest(".filter[data-filter-type]");
                        if ($filter.length) {
                            const filterType = $filter.data("filter-type");
                            const $overridableUrlInput = $(`.filter-overridable-url[data-filter-type="${filterType}"]`);
                            if (!$overridableUrlInput.length)
                                return;
                            const overridableUrl = $overridableUrlInput.val();
                            if (overridableUrl == null ||
                                typeof overridableUrl !== "string" ||
                                CS.Helper.isNullOrWhiteSpace(overridableUrl))
                                return;
                            yield this.handlePersonaDropdownItemClick(personaId, overridableUrl);
                        }
                    }),
                });
                CS.DOM.$body.offon("click.personaDropdownCsFilterItemClicked", "#dropdown-persona-drpdwn-cs-filters .list-item", (e) => __awaiter(this, void 0, void 0, function* () {
                    const $item = $(e.currentTarget);
                    const id = $item.data("value");
                    const url = $item.data("extravalues").CustomUrl;
                    yield this.handlePersonaDropdownItemClick(id, url);
                }));
                CS.DOM.$body.offon("click.personaDropdownAutocompletePlayersItemClicked", "#dropdown-autocomplete-find-players-persona-drpdwn-cs-filters .list-item", (e) => __awaiter(this, void 0, void 0, function* () {
                    const $item = $(e.currentTarget);
                    const id = $item.data("value");
                    let $customUrlInput = $("#AutocompleteOpponentsCustomUrl");
                    if (!$customUrlInput.length)
                        $customUrlInput = $("#AutocompletePlayersCustomUrl");
                    if ($customUrlInput.length) {
                        const url = $customUrlInput.val();
                        yield this.handlePersonaDropdownItemClick(id, url);
                    }
                    else {
                        console.error("Hidden inputs #AutocompletePlayersCustomUrl || #AutocompleteOpponentsCustomUrl were not found.");
                    }
                }));
                CS.DOM.$body.offon("click.personaDropdownAutocompleteItemClicked", "#dropdown-autocomplete-find-opponents-persona-drpdwn-cs-filters .list-item", (e) => __awaiter(this, void 0, void 0, function* () {
                    const $item = $(e.currentTarget);
                    const id = $item.data("value");
                    let $customUrlInput = $("#AutocompleteOpponentsCustomUrl");
                    if (!$customUrlInput.length)
                        $customUrlInput = $("#AutocompletePlayersCustomUrl");
                    if ($customUrlInput.length) {
                        const url = $customUrlInput.val();
                        yield this.handlePersonaDropdownItemClick(id, url);
                    }
                    else {
                        console.error("Hidden inputs #AutocompletePlayersCustomUrl || #AutocompleteOpponentsCustomUrl were not found.");
                    }
                }));
                CS.DOM.$body.offon("click.eventDropdownItemClicked", "#dropdown-event-drpdwn-cs-filters .list-item", (e) => __awaiter(this, void 0, void 0, function* () {
                    const $item = $(e.currentTarget);
                    const id = $item.data("value");
                    const url = $item.data("extravalues").url;
                    yield this.handleEventDropdownItemClick(id, url);
                }));
                CS.DOM.$body.offon("click.eventDropdownAutocompleteItemClicked", "#dropdown-autocomplete-find-events-event-drpdwn-cs-filters .list-item", (e) => __awaiter(this, void 0, void 0, function* () {
                    const $item = $(e.currentTarget);
                    const id = $item.data("value");
                    const $customUrlInput = $("#AutocompleteEventsCustomUrl");
                    if ($customUrlInput.length) {
                        const url = $customUrlInput.val();
                        yield this.handleEventDropdownItemClick(id, url);
                    }
                    else {
                        console.error("Hidden input #AutocompleteEventsCustomUrl was not found.");
                    }
                }));
                CS.DOM.$body.offon("click.operatorDropdownOpponentsWall", "#dropdown-autocomplete-operators .list-item.selectable", (e) => __awaiter(this, void 0, void 0, function* () {
                    CS.Helper.log("operatorDropdownOpponentsWall", "click");
                    const $listItem = $(e.currentTarget);
                    const operatorId = $listItem.data("value");
                    const $customUrlInput = $("#AutocompleteOperatorsCustomUrl");
                    if ($customUrlInput.length) {
                        const url = $customUrlInput.val();
                        yield this.handleOperatorDropdownItemClick(operatorId, url);
                    }
                    else {
                        console.error("Hidden input #AutocompleteOperatorsCustomUrl was not found.");
                    }
                }));
                CS.DivisionsPicker.OnItemClick("filter-item-divisions-picker", (divisionId, customUrl, divisionsPicker) => __awaiter(this, void 0, void 0, function* () {
                    yield this.handleDivisionClick(divisionId, customUrl);
                }));
                CS.DOM.$body.offon("click.csFiltersToggled", ".filters.control-cs .filters-toggle", (e) => {
                    this.toggleCollapsedLayoutState();
                });
                // DropDown.Events.ListItemClicked({
                //   selector: DOM.$body,
                //   childSelector: ".cs-sort-dropdown",
                //   callback: this.handleSortItemClick,
                // });
                this.initializeInputsState();
                this.initializeDatePickersState();
            }
            OnDispose() {
                this.Trigger(Filters.EventNames.Disposed, {
                    jqueryEventObject: null,
                    data: {
                        inDrawer: this.InDrawer,
                    },
                });
            }
            UpdateFiltersStateInBrowserUrl(filtersState) {
                return __awaiter(this, void 0, void 0, function* () {
                    // Get the current url and update the filters state param.
                    const currentUrl = new URL(window.location.href);
                    const queryString = currentUrl.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersstate");
                    const compressedFiltersState = yield CS.Helper.gZipCompress(filtersState);
                    if (filtersStateParam != null) {
                        // urlParams.set("filtersState", compressedFiltersState);
                        // remove the param
                        urlParams.delete("filtersState");
                    }
                    else {
                        // urlParams.append("filtersState", compressedFiltersState);
                    }
                    // Create a new url with the updated filters state param.
                    const newUrl = new URL(currentUrl.origin + currentUrl.pathname + "?" + urlParams);
                    let newUrlString = newUrl.href;
                    if (newUrlString.includes("?")) {
                        newUrlString += "&filtersState=" + compressedFiltersState;
                    }
                    else {
                        newUrlString += "?filtersState=" + compressedFiltersState;
                    }
                    CS.PopState.OnNavigation(newUrlString, true);
                });
            }
            static UpdateFiltersStateInBrowserUrlStatic(filtersState) {
                return __awaiter(this, void 0, void 0, function* () {
                    // Get the current url and update the filters state param.
                    const currentUrl = new URL(window.location.href);
                    const queryString = currentUrl.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersstate");
                    const compressedFiltersState = yield CS.Helper.gZipCompress(filtersState);
                    if (filtersStateParam != null) {
                        // urlParams.set("filtersState", compressedFiltersState);
                        // remove the param
                        urlParams.delete("filtersState");
                    }
                    else {
                        // urlParams.append("filtersState", compressedFiltersState);
                    }
                    // Create a new url with the updated filters state param.
                    const newUrl = new URL(currentUrl.origin + currentUrl.pathname + "?" + urlParams);
                    let newUrlString = newUrl.href;
                    if (newUrlString.includes("?")) {
                        newUrlString += "&filtersState=" + compressedFiltersState;
                    }
                    else {
                        newUrlString += "?filtersState=" + compressedFiltersState;
                    }
                    CS.PopState.OnNavigation(newUrlString, true);
                });
            }
            // private async updateCollapsedStateInUrl(url: string): Promise<string> {
            //   if (!url) {
            //     console.warn("updateCollapsedStateInUrl null url");
            //     return null;
            //   }
            //   const containsOrigin = url.indexOf(window.location.origin) !== -1;
            //   if (!containsOrigin) url = window.location.origin + url;
            //   const urlObject = new URL(url);
            //   const queryString = urlObject.search;
            //   const urlParams = new URLSearchParams(queryString);
            //   const filtersStateParam = urlParams.get("filtersStateSerialized");
            //   const filtersState = filtersStateParam
            //     ? JSON.parse(decodeURIComponent(await CS.Helper.gZipDecompress(filtersStateParam)))
            //     : {};
            //   filtersState.CollapsedLayout = this.$Control.hasClass("collapsed");
            //   urlParams.set(
            //     "filtersStateSerialized",
            //     await CS.Helper.gZipCompress(JSON.stringify(filtersState))
            //   );
            //   return containsOrigin
            //     ? urlObject.origin + urlObject.pathname + "?" + urlParams
            //     : urlObject.pathname + "?" + urlParams;
            // }
            extractFiltersStateFromUrl(url) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (url.indexOf(window.location.origin) === -1) {
                        url = window.location.origin + url;
                    }
                    const urlObject = new URL(url);
                    const queryString = urlObject.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersStateSerialized");
                    if (!filtersStateParam) {
                        return null;
                    }
                    const decompressed = yield CS.Helper.gZipDecompress(filtersStateParam);
                    return decompressed;
                });
            }
            static ExtractFiltersStateFromUrl(url) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (url.indexOf(window.location.origin) === -1) {
                        url = window.location.origin + url;
                    }
                    const urlObject = new URL(url);
                    const queryString = urlObject.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersStateSerialized");
                    if (!filtersStateParam) {
                        return null;
                    }
                    const decompressed = yield CS.Helper.gZipDecompress(filtersStateParam);
                    return decompressed;
                });
            }
            /**
             * Encode value and sets it as filterType's value in the url.
             */
            replaceValueInOverridableUrl(overridableUrl, value, filterType) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (overridableUrl.indexOf(window.location.origin) === -1) {
                        overridableUrl = window.location.origin + overridableUrl;
                    }
                    const url = new URL(overridableUrl);
                    const urlParams = new URLSearchParams(url.search);
                    const filtersStateParam = urlParams.get("filtersStateSerialized");
                    const decompressed = yield CS.Helper.gZipDecompress(filtersStateParam);
                    const replaced = decompressed.replace(`${this.OverridableValuePrefixAndSuffix}${filterType}${this.OverridableValuePrefixAndSuffix}`, value);
                    const compressed = yield CS.Helper.gZipCompress(replaced);
                    urlParams.set("filtersStateSerialized", compressed);
                    url.search = urlParams.toString();
                    return url.href;
                });
            }
            static ReplaceValueInOverridableUrl(overridableUrl, value, filterType) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (overridableUrl.indexOf(window.location.origin) === -1) {
                        overridableUrl = window.location.origin + overridableUrl;
                    }
                    const url = new URL(overridableUrl);
                    const urlParams = new URLSearchParams(url.search);
                    const filtersStateParam = urlParams.get("filtersStateSerialized");
                    const decompressed = yield CS.Helper.gZipDecompress(filtersStateParam);
                    const replaced = decompressed.replace(`${this.DefaultOverridableValuePrefixAndSuffix}${filterType}${this.DefaultOverridableValuePrefixAndSuffix}`, value);
                    const compressed = yield CS.Helper.gZipCompress(replaced);
                    urlParams.set("filtersStateSerialized", compressed);
                    url.search = urlParams.toString();
                    return url.href;
                });
            }
            initializeInputsState() {
                const $allInputs = $(".control-cs.cs-filter-input:not(.datepicker)");
                if ($allInputs.length) {
                    $allInputs.each((index, element) => {
                        const $element = $(element);
                        const id = $element.attr("id");
                        const $childInput = $element.find(`#${id}-child`);
                        // Extract data from each input.
                        const filterType = $childInput.attr("dataFilterType");
                        const filterContext = $childInput.attr("datafiltercontext");
                        // The last character of the id is the index of the input within the filter container.
                        // It is used to keep track of the order of the inputs, since there's sometime more (per example, min/max CSR).
                        const localIndex = parseInt(id.charAt(id.length - 1));
                        // If there's no value, use OverridableValuePrefixAndSuffix.
                        let value = $childInput.val();
                        if (value === "") {
                            value = this.OverridableValuePrefixAndSuffix;
                        }
                        // Assign the value to the dictionary.
                        this.inputsState[id] = {
                            value: value,
                            changedRecently: false,
                            filterType: filterType,
                            filterContext: filterContext,
                            index: localIndex,
                        };
                    });
                }
            }
            initializeDatePickersState() {
                const $allInputs = $(".control-cs.cs-filter-input.datepicker");
                if ($allInputs.length) {
                    $allInputs.each((index, element) => {
                        const $element = $(element);
                        const id = $element.attr("id");
                        const $childInput = $element.find(`#${id}-child`);
                        // Extract data from each input.
                        const filterType = $childInput.attr("dataFilterType");
                        const filterContext = $childInput.attr("datafiltercontext");
                        // The last character of the id is the index of the input within the filter container.
                        // It is used to keep track of the order of the inputs, since there's sometime more (per example, min/max CSR).
                        const localIndex = parseInt(id.charAt(id.length - 1));
                        // If there's no value, use OverridableValuePrefixAndSuffix.
                        let value = $childInput.val();
                        if (value === "") {
                            value = this.OverridableValuePrefixAndSuffix;
                        }
                        // Assign the value to the dictionary.
                        this.datePickersState[id] = {
                            value: value,
                            changedRecently: false,
                            filterType: filterType,
                            filterContext: filterContext,
                            index: localIndex,
                        };
                    });
                }
            }
            toggleCollapsedLayoutState(onlyExpand = false) {
                const wasCollapsed = this.$Control.hasClass("collapsed");
                if (!wasCollapsed && onlyExpand)
                    return;
                const toggledStateHeight = CS.Helper.GetHeightOfHiddenElement(this.$Control, wasCollapsed ? "" : "collapsed", wasCollapsed ? "collapsed" : "");
                this.$Control.css({ height: this.$Control.outerHeight() });
                //const $filtersToggle = this.$Control.find(".filters-toggle");
                //$filtersToggle.css({ position: "relative" });
                CS.Lag(this.$Control.attr("id"), 100, () => __awaiter(this, void 0, void 0, function* () {
                    this.$Control.toggleClass("collapsed");
                    this.layoutState.collapsed = !this.layoutState.collapsed;
                    const data = {
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(window.location.href),
                    };
                    const $customFilterItem = $(`.item[data-value="custom-preset"]`);
                    if ($customFilterItem.length) {
                        if (this.layoutState.collapsed) {
                            $customFilterItem.show();
                        }
                        else {
                            $customFilterItem.hide();
                        }
                    }
                    this.Trigger(Filters.EventNames.FiltersToggleClicked, { jqueryEventObject: null, data });
                }));
                this.$Control.animate({ height: toggledStateHeight }, 250, () => {
                    this.$Control.css({ height: "auto" });
                    //$filtersToggle.css({ position: "sticky" });
                });
            }
        }
        Filters.DefaultOverridableValuePrefixAndSuffix = "___";
        Controls.Filters = Filters;
        (function (Filters) {
            class Events {
                static ItemClicked(param) {
                    Controls.RegisterEvent(Filters, EventNames.ItemClicked, param);
                }
                static FilterToggleClicked(param) {
                    Controls.RegisterEvent(Filters, EventNames.FilterToggleClicked, param);
                }
                /**
                 * Triggered 1 second after an input has been changed. Immediately if it's a date picker.
                 */
                static TextChanged(param) {
                    Controls.RegisterEvent(Filters, EventNames.TextChanged, param);
                }
                static SortItemClicked(param) {
                    Controls.RegisterEvent(Filters, EventNames.SortItemClicked, param);
                }
                static FiltersToggleClicked(param) {
                    Controls.RegisterEvent(Filters, EventNames.FiltersToggleClicked, param);
                }
                static Disposed(param) {
                    Controls.RegisterEvent(Filters, EventNames.Disposed, param);
                }
            }
            Filters.Events = Events;
            class EventNames {
            }
            EventNames.ItemClicked = "item-clicked";
            EventNames.FilterToggleClicked = "filter-toggle-clicked";
            EventNames.FiltersToggleClicked = "filters-toggle-clicked";
            EventNames.TextChanged = "filter-input-text-changed";
            EventNames.SortItemClicked = "sort-item-clicked";
            EventNames.Disposed = "filters-disposed";
            Filters.EventNames = EventNames;
        })(Filters = Controls.Filters || (Controls.Filters = {}));
        class FiltersBar extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.uiFreezed = false;
                this.handleSortItemClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    const $listItem = $(e.currentTarget);
                    const url = $listItem.attr("data-value");
                    const data = {
                        url: url,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(url),
                    };
                    this.Trigger(FiltersBar.EventNames.SortItemClicked, { jqueryEventObject: null, data });
                });
                this.handleChipWithToggleSwitchClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    const $chip = $(e.currentTarget);
                    const filterType = $chip.attr("data-filter-type");
                    if (CS.Helper.isNullOrWhiteSpace(filterType))
                        return;
                    const filterContext = $chip.attr("data-filter-context");
                    if (CS.Helper.isNullOrWhiteSpace(filterContext))
                        return;
                    let toggleUrl = $chip.attr("data-toggle-url");
                    if (CS.Helper.isNullOrWhiteSpace(toggleUrl)) {
                        // Try to use the overridable url if the toggle url is not defined.
                        // It will be the case if it's a preset filter item.
                        const overridableUrl = $chip.attr("data-overridable-url");
                        if (CS.Helper.isNullOrWhiteSpace(overridableUrl))
                            return;
                        const presetValue = $chip.attr("data-preset-value");
                        if (CS.Helper.isNullOrWhiteSpace(presetValue))
                            return;
                        toggleUrl = yield Filters.ReplaceValueInOverridableUrl(overridableUrl, presetValue, filterType);
                    }
                    if (CS.Helper.isNullOrWhiteSpace(toggleUrl))
                        return;
                    const data = {
                        toggleUrl: toggleUrl,
                        filterType: filterType,
                        context: filterContext,
                        filtersStateSerialized: yield this.extractFiltersStateFromUrl(toggleUrl),
                    };
                    CS.Helper.log("FiltersBar", "Triggering ChipClicked event", data);
                    this.Trigger(FiltersBar.EventNames.ChipClicked, { jqueryEventObject: e, data });
                });
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnControlRendered() { }
            OnBindEvents() {
                this.$Control.offon("click.filterChipWithToggleSwitchClicked", ".chip.chip--with-toggle-switch", this.handleChipWithToggleSwitchClick.bind(this));
                // DropDown.Events.ListItemClicked({
                //   selector: DOM.$body,
                //   childSelector: ".cs-sort-dropdown",
                //   callback: this.handleSortItemClick,
                // });
                CS.DOM.$body.offon("click.sortItemClicked", ".cs-sort-dropdown .list-item", this.handleSortItemClick.bind(this));
            }
            OnDispose() {
                this.Trigger(Filters.EventNames.Disposed, {
                    jqueryEventObject: null,
                    data: null,
                });
            }
            extractFiltersStateFromUrl(url) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (url.indexOf(window.location.origin) === -1) {
                        url = window.location.origin + url;
                    }
                    const urlObject = new URL(url);
                    const queryString = urlObject.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersStateSerialized");
                    if (!filtersStateParam) {
                        return null;
                    }
                    const decompressed = yield CS.Helper.gZipDecompress(filtersStateParam);
                    return decompressed;
                });
            }
            UpdateFiltersStateInBrowserUrl(filtersState) {
                return __awaiter(this, void 0, void 0, function* () {
                    // Get the current url and update the filters state param.
                    const currentUrl = new URL(window.location.href);
                    const queryString = currentUrl.search;
                    const urlParams = new URLSearchParams(queryString);
                    const filtersStateParam = urlParams.get("filtersstate");
                    const compressedFiltersState = yield CS.Helper.gZipCompress(filtersState);
                    const areEqual = compressedFiltersState == filtersStateParam;
                    if (filtersStateParam != null) {
                        // urlParams.set("filtersState", compressedFiltersState);
                        // remove the param
                        urlParams.delete("filtersState");
                    }
                    else {
                        // urlParams.append("filtersState", compressedFiltersState);
                    }
                    // Create a new url with the updated filters state param.
                    const newUrl = new URL(currentUrl.origin + currentUrl.pathname + "?" + urlParams);
                    let newUrlString = newUrl.href;
                    if (newUrlString.includes("?")) {
                        newUrlString += "&filtersState=" + compressedFiltersState;
                    }
                    else {
                        newUrlString += "?filtersState=" + compressedFiltersState;
                    }
                    CS.PopState.OnNavigation(newUrlString, true);
                });
            }
        }
        Controls.FiltersBar = FiltersBar;
        (function (FiltersBar) {
            class Events {
                static ChipClicked(param) {
                    Controls.RegisterEvent(FiltersBar, EventNames.ChipClicked, param);
                }
                static SortItemClicked(param) {
                    Controls.RegisterEvent(FiltersBar, EventNames.SortItemClicked, param);
                }
            }
            FiltersBar.Events = Events;
            class EventNames {
            }
            EventNames.ChipClicked = "filter-chip-clicked";
            EventNames.SortItemClicked = "filter-sort-item-clicked";
            FiltersBar.EventNames = EventNames;
        })(FiltersBar = Controls.FiltersBar || (Controls.FiltersBar = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=filters.js.map
